import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";

export default function Layout() {
  const location = useLocation();

  useEffect(() => {
    document.body.classList.remove("sidebar-open");
  }, [location.pathname]);

  return (
    <div className="wrapper">
      <Header />
      <Outlet />
    </div>
  );
}
